module.exports = __webpack_public_path__ + "static/img/xn.3f494a8c.png";